export function planCanvasResize({
  previousWidth,
  previousHeight,
  previousPixelRatio,
  nextWidth,
  nextHeight,
  nextPixelRatio,
}) {
  const changed = Math.abs(nextWidth - previousWidth) >= .5
    || Math.abs(nextHeight - previousHeight) >= .5
    || Math.abs(nextPixelRatio - previousPixelRatio) >= .01;

  return {
    changed,
    preservedWidth: previousWidth || nextWidth,
    preservedHeight: previousHeight || nextHeight,
  };
}
